import {
  type ShoppingCartContext,
  useShoppingExperience,
} from '@seek/shopping-cart-provider';

export const useShoppingCart = () => useShoppingExperience();

export type ShoppingCartContextProps = React.ContextType<
  typeof ShoppingCartContext
>;
